import React, { useState } from "react";

const AdminControls = () => {
  const [selectedCohort, setSelectedCohort] = useState("all");

  const pending = [
    {
      id: "TRD-00184",
      role: "Trader",
      name: "AlphaGold",
      tier: "MICRO",
      survivability: "94%",
      risk: "LOW",
      requestedAt: "2026-01-20",
    },
    {
      id: "ANL-00062",
      role: "Analyst",
      name: "LondonSession",
      tier: "Signal Only",
      survivability: "81%",
      risk: "MEDIUM",
      requestedAt: "2026-01-19",
    },
  ];

  const highRisk = [
    {
      id: "TRD-00077",
      role: "Trader",
      name: "XAUHighRisk",
      tier: "RETAIL",
      risk: "EXTREME",
      flag: "Critical DD > 50%",
    },
    {
      id: "ANL-00021",
      role: "Analyst",
      name: "OverLeverageFX",
      tier: "Signal Only",
      risk: "HIGH",
      flag: "Abnormal lot escalation",
    },
  ];

  return (
    <section className="section admin-controls">
      <h2 className="section-title">Admin Controls (Dummy)</h2>
      <p className="section-subtitle">
        UI kontrol admin for approve/reject, suspend, and distribusi bonus pool. Saat ini dummy, nanti dihubungkan
        ke API admin backend.
      </p>

      <div className="admin-controls-grid">
        <div className="card">
          <h4>Pending Approvals</h4>
          <table className="table">
            <thead>
              <tr>
                <th>User</th>
                <th>Role</th>
                <th>Tier</th>
                <th>Survivability</th>
                <th>Risk</th>
                <th>Requested</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pending.map((p) => (
                <tr key={p.id}>
                  <td>{p.name}</td>
                  <td>{p.role}</td>
                  <td>{p.tier}</td>
                  <td>{p.survivability}</td>
                  <td>{p.risk}</td>
                  <td>{p.requestedAt}</td>
                  <td>
                    <div className="table-actions">
                      <button
                        type="button"
                        className="btn btn-xs btn-primary"
                        onClick={() => alert(`Dummy: approve ${p.id}`)}
                      >
                        Approve
                      </button>
                      <button
                        type="button"
                        className="btn btn-xs btn-secondary"
                        onClick={() => alert(`Dummy: reject ${p.id}`)}
                      >
                        Reject
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="table-note">
            Nanti backend bisa pakai status seperti PENDING / APPROVED / REJECTED di tabel users atau roles.
          </p>
        </div>

        <div className="card">
          <h4>High Risk & Compliance Flags</h4>
          <div className="form-row">
            <label>View Cohort</label>
            <select
              className="input"
              value={selectedCohort}
              onChange={(e) => setSelectedCohort(e.target.value)}
            >
              <option value="all">All</option>
              <option value="critical">Critical only</option>
              <option value="institutional">Institutional only</option>
            </select>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>User</th>
                <th>Role</th>
                <th>Tier</th>
                <th>Risk</th>
                <th>Flag</th>
                <th>Controls</th>
              </tr>
            </thead>
            <tbody>
              {highRisk.map((u) => (
                <tr key={u.id}>
                  <td>{u.name}</td>
                  <td>{u.role}</td>
                  <td>{u.tier}</td>
                  <td>{u.risk}</td>
                  <td>{u.flag}</td>
                  <td>
                    <div className="table-actions">
                      <button
                        type="button"
                        className="btn btn-xs btn-secondary"
                        onClick={() => alert(`Dummy: suspend ${u.id}`)}
                      >
                        Suspend
                      </button>
                      <button
                        type="button"
                        className="btn btn-xs btn-primary"
                        onClick={() => alert(`Dummy: allow only Pending Allocation for ${u.id}`)}
                      >
                        Force Pending Allocation
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="table-note">
            “Pending Allocation” bisa dipakai for handle akun high-risk yang hanya boleh dilihat, bukan langsung
            dialokasikan dana baru.
          </p>
        </div>
      </div>

      <div className="card admin-mass-actions">
        <h4>Mass Actions</h4>
        <div className="mass-actions-grid">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => alert("Dummy: recalc AlphaRank for all accounts.")}
          >
            Recalculate AlphaRank™ for All
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => alert("Dummy: simulate bonus pool distribution.")}
          >
            Simulate Bonus Pool Distribution
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => alert("Dummy: lock month & finalize revenue.")}
          >
            Close Month & Lock Revenue
          </button>
        </div>
        <p className="table-note">
          Backend nanti bisa expose endpoint admin khusus (protected) for menjalankan operasi-opsi ini secara
          terkontrol.
        </p>
      </div>
    </section>
  );
};


// ── BannerControl (exported separately, used in AdminDashboard) ──
export function BannerControl() {
  const [banner, setBanner] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  const tok = localStorage.getItem("access_token") || localStorage.getItem("token");

  React.useEffect(() => {
    fetch("/api/admin/banner", { headers: { Authorization: "Bearer " + tok } })
      .then(r => r.json())
      .then(d => { if (d.ok) setBanner(d.banner); })
      .catch(() => {});
  }, []);

  const save = (patch) => {
    setSaving(true); setMsg("");
    fetch("/api/admin/banner", {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + tok },
      body: JSON.stringify(patch),
    }).then(r => r.json())
      .then(d => { setMsg(d.ok ? "Saved " : d.error || "Error"); setBanner(b => ({...b, ...patch})); })
      .catch(() => setMsg("Error"))
      .finally(() => setSaving(false));
  };

  if (!banner) return <div style={{fontSize:12,color:"var(--text-faint)"}}>Loading banner...</div>;

  const inp = {
    width:"100%", padding:"8px 10px", borderRadius:6,
    border:"1px solid var(--border)", background:"var(--bg-elevated)",
    color:"var(--text-main)", fontSize:12, marginBottom:8,
  };

  return (
    <div style={{background:"var(--bg-surface)",border:"1px solid var(--border)",borderRadius:10,padding:20}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"var(--text-main)",marginBottom:2}}>Announcement Banner</div>
          <div style={{fontSize:11,color:"var(--text-faint)"}}>Shown at top of landing page</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:11,color:banner.is_active?"var(--success)":"var(--text-faint)",fontWeight:600}}>
            {banner.is_active ? "LIVE" : "OFF"}
          </span>
          <div onClick={() => save({is_active: !banner.is_active})}
            style={{width:40,height:22,borderRadius:11,cursor:"pointer",position:"relative",transition:"background 0.2s",
              background:banner.is_active?"var(--success)":"var(--border)"}}>
            <div style={{position:"absolute",top:3,left:banner.is_active?20:3,width:16,height:16,
              borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/>
          </div>
        </div>
      </div>
      <div style={{fontSize:11,color:"var(--text-faint)",marginBottom:4}}>Message</div>
      <input style={inp} value={banner.message}
        onChange={e => setBanner(b => ({...b, message: e.target.value}))}
        onBlur={e => save({message: e.target.value})} />
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <div>
          <div style={{fontSize:11,color:"var(--text-faint)",marginBottom:4}}>CTA Text</div>
          <input style={inp} value={banner.cta_text}
            onChange={e => setBanner(b => ({...b, cta_text: e.target.value}))}
            onBlur={e => save({cta_text: e.target.value})} />
        </div>
        <div>
          <div style={{fontSize:11,color:"var(--text-faint)",marginBottom:4}}>CTA Link</div>
          <input style={inp} value={banner.cta_link}
            onChange={e => setBanner(b => ({...b, cta_link: e.target.value}))}
            onBlur={e => save({cta_link: e.target.value})} />
        </div>
      </div>
      {msg && <div style={{fontSize:11,color:"var(--success)",marginTop:6}}>{msg}</div>}
      <div style={{marginTop:12,padding:"10px 14px",background:"var(--bg-elevated)",borderRadius:7,
        fontSize:11,color:"var(--text-faint)"}}>
        Preview: <span style={{color:"var(--accent)",fontWeight:500}}>{banner.message}</span>
        {" "}<span style={{background:"var(--accent)",color:"#fff",padding:"1px 8px",borderRadius:4,fontSize:10,fontWeight:700}}>
          {banner.cta_text} →
        </span>
      </div>
    </div>
  );
}

export default AdminControls;
